import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { finalize, Observable, Subject, takeUntil } from 'rxjs';
import { NewsService } from '../../services/news.service';
import { HttpClientModule } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-news-gamc',
  standalone: true,
  imports: [NgFor, HttpClientModule, NgIf, DialogModule],
  providers: [NewsService],
  templateUrl: './news-gamc.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NewsGAMCComponent implements OnInit, OnDestroy {

  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

  @Input()
  public scrollSectionId!: string;

  public lastNewsList: any[] | null = null;

  private _subscription: Subject<void>;
  public isVideoPlaying: boolean;
  public showDetail: boolean = false;
  public isLoading: boolean = false;
  public showNews: boolean = false;
  public selectedItem: any = null;

  constructor(private _loaderService: LoaderService,
              private _newsService: NewsService,
              private _cdr: ChangeDetectorRef) {
    this._subscription = new Subject<void>();
    this.isVideoPlaying = false;
  }

  ngOnInit(): void {
    this._getLastNews();
  }
  
  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public setVideoStartTime(video: HTMLVideoElement, startTime: number) {
    video.currentTime = startTime;
  }

  public onVideoPlay() {
    this.isVideoPlaying = true;
  }

  public onVideoPause() {
    this.isVideoPlaying = false;
  }

  public getLink(file: string): string {
    const url: string = 'https://www.cochabamba.bo/' + file;
    
    return url;
  }

  public getBackgroundLink(file: string): string {
    const url: string = 'https://www.cochabamba.bo/' + file;
    
    return `url(${url})`;
  }

  public getDate(ISOdate: string) {
    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const date = new Date(ISOdate);
    const day = date.getDate();
    const month = meses[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} de ${year}`;
}

  public verifyMP4Extension(path: string) {
    let extension = path?.split('.')?.pop()?.toLowerCase();
    
    return extension === 'mp4';
  }

  public closeNewDetail() {
    this.showDetail = false;
    this.selectedItem = null;
    this._cdr.detectChanges();
  }

  public scrollToFeatureSection(): any {
    const element = document.getElementById(this.scrollSectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  private _getLastNews() {
    this.lastNewsList = null;
    
    try {
      this._newsService.getLastNews()
        .pipe(
          takeUntil(this._subscription)
        )
        .subscribe((newsList: any) => {
          this.lastNewsList = newsList;
          this.showNews = true;
          this._cdr.detectChanges();
        }, (error) => {
          this.showNews = false;
          console.error("Error fetching news:", error);
          this._cdr.detectChanges();
        });
    } catch (error) {
      this.showNews = false;
      console.error("Unexpected error:", error);
      this._cdr.detectChanges();
    }
  }

  public selectItem(item: any) {
    this._loaderService.show();
    this._getPost(item.slug).subscribe({
      next: (newsList: any) => {
        this.selectedItem = newsList;
        
        this.showDetail = true;
        this._loaderService.hide();
        this._cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('Error fetching post:', error);
        this._loaderService.hide();
        this._cdr.detectChanges();
      }
    });
  }

  private _getPost(slug: string): Observable<any> {
    this.selectedItem = null;
    return this._newsService.getPost(slug).pipe(
      takeUntil(this._subscription),
      finalize(() => {})
    );
  }
}
